"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPortMath = void 0;
const utils_1 = require("./utils");
exports.ViewPortMath = {
    deriveActualZoomBounds({ containerWidth, containerHeight }, bounds, defaultZoomBounds) {
        var _a, _b, _c, _d;
        let min;
        let max;
        if ((bounds === null || bounds === void 0 ? void 0 : bounds.x) && ((_a = bounds.x) === null || _a === void 0 ? void 0 : _a[0]) !== undefined && ((_b = bounds.x) === null || _b === void 0 ? void 0 : _b[1]) !== undefined) {
            const space = bounds.x[1] - bounds.x[0];
            min = containerWidth / space;
        }
        if ((bounds === null || bounds === void 0 ? void 0 : bounds.y) && ((_c = bounds.y) === null || _c === void 0 ? void 0 : _c[0]) !== undefined && ((_d = bounds.y) === null || _d === void 0 ? void 0 : _d[1]) !== undefined) {
            const space = bounds.y[1] - bounds.y[0];
            min = min ? Math.max(min, containerHeight / space) : containerHeight / space;
        }
        if (bounds === null || bounds === void 0 ? void 0 : bounds.zoom) {
            if (bounds.zoom[0] !== undefined) {
                min = min ? Math.max(min, bounds.zoom[0]) : bounds.zoom[0];
            }
            if (bounds.zoom[1] !== undefined) {
                max = bounds.zoom[1];
            }
        }
        if (min === undefined) {
            if (max === undefined) {
                return { zoom: defaultZoomBounds };
            }
            return { zoom: [defaultZoomBounds[0], max] };
        }
        else {
            return { zoom: [min, max !== null && max !== void 0 ? max : defaultZoomBounds[1]] };
        }
    },
    centerFitArea(values, bounds, area, additionalBounds) {
        const { left, top, width, height } = area;
        const cx = left + width / 2;
        const cy = top + height / 2;
        const zoomFactorBasedOnWidth = values.containerWidth / width;
        const zoomFactorBasedOnHeight = values.containerHeight / height;
        let newZoomFactor = Math.min(zoomFactorBasedOnWidth, zoomFactorBasedOnHeight);
        newZoomFactor = (0, utils_1.clamp)(newZoomFactor, additionalBounds === null || additionalBounds === void 0 ? void 0 : additionalBounds.zoom);
        newZoomFactor = (0, utils_1.clamp)(newZoomFactor, bounds.zoom);
        exports.ViewPortMath.updateZoom(values, bounds, newZoomFactor);
        exports.ViewPortMath.updateTopLeft(values, bounds, cx - values.width / 2, cy - values.height / 2);
    },
    centerFitHorizontalArea(values, bounds, left, width, additionalBounds) {
        let newZoomFactor = values.containerWidth / width;
        newZoomFactor = (0, utils_1.clamp)(newZoomFactor, additionalBounds === null || additionalBounds === void 0 ? void 0 : additionalBounds.zoom);
        newZoomFactor = (0, utils_1.clamp)(newZoomFactor, bounds.zoom);
        const top = values.top;
        exports.ViewPortMath.updateZoom(values, bounds, newZoomFactor);
        exports.ViewPortMath.updateTopLeft(values, bounds, left, top);
    },
    updateBounds(values, bounds) {
        values.zoomFactor = (0, utils_1.clamp)(values.zoomFactor, bounds.zoom);
        const oldVirtualSpaceVisibleSpaceWidth = values.width;
        const oldVirtualSpaceVisibleSpaceHeight = values.height;
        values.width = values.containerWidth / values.zoomFactor;
        values.height = values.containerHeight / values.zoomFactor;
        values.centerX = (0, utils_1.clampCenterOfLength)(values.centerX + (values.width - oldVirtualSpaceVisibleSpaceWidth) / 2, values.width, bounds === null || bounds === void 0 ? void 0 : bounds.x);
        values.centerY = (0, utils_1.clampCenterOfLength)(values.centerY + (values.height - oldVirtualSpaceVisibleSpaceHeight) / 2, values.height, bounds === null || bounds === void 0 ? void 0 : bounds.y);
        values.left = values.centerX - values.width / 2;
        values.top = values.centerY - values.height / 2;
    },
    // Combine these
    updateBy(values, bounds, dx, dy, dZoom, anchorContainerX, anchorContainerY) {
        // The math in here could probably get cleaned up...
        const oldVirtualSpaceVisibleSpaceWidth = values.containerWidth / values.zoomFactor;
        const oldVirtualSpaceVisibleSpaceHeight = values.containerHeight / values.zoomFactor;
        // Basic pan handling
        const virtualSpaceNewLeft = values.left + dx;
        const virtualSpaceNewTop = values.top + dy;
        if (dZoom !== undefined && dZoom !== 0) {
            exports.ViewPortMath.updateZoom(values, bounds, values.zoomFactor + dZoom);
        }
        // Zoom BUT keep the view coordinate under the mouse pointer CONSTANT
        const virtualSpaceVisibleWidthDelta = values.width - oldVirtualSpaceVisibleSpaceWidth;
        const virtualSpaceVisibleHeightDelta = values.height - oldVirtualSpaceVisibleSpaceHeight;
        // The reason we use x and y here is to zoom in or out towards where the
        // pointer is positioned
        const xFocusPercent = anchorContainerX === undefined ? 0.5 : anchorContainerX / values.containerWidth;
        const yFocusPercent = anchorContainerY === undefined ? 0.5 : anchorContainerY / values.containerHeight;
        values.centerX = (0, utils_1.clampCenterOfLength)(virtualSpaceNewLeft - virtualSpaceVisibleWidthDelta * xFocusPercent + values.width / 2, values.width, bounds === null || bounds === void 0 ? void 0 : bounds.x);
        values.centerY = (0, utils_1.clampCenterOfLength)(virtualSpaceNewTop - virtualSpaceVisibleHeightDelta * yFocusPercent + values.height / 2, values.height, bounds === null || bounds === void 0 ? void 0 : bounds.y);
        values.left = values.centerX - values.width / 2;
        values.top = values.centerY - values.height / 2;
    },
    updateTopLeft(values, bounds, x, y) {
        values.centerX = (0, utils_1.clampCenterOfLength)(x + values.width / 2, values.width, bounds.x);
        values.centerY = (0, utils_1.clampCenterOfLength)(y + values.height / 2, values.height, bounds.y);
        values.left = values.centerX - values.width / 2;
        values.top = values.centerY - values.height / 2;
    },
    updateZoom(values, bounds, zoomFactor) {
        if (zoomFactor !== undefined) {
            values.zoomFactor = (0, utils_1.clamp)(zoomFactor, bounds.zoom);
            values.width = values.containerWidth / values.zoomFactor;
            values.height = values.containerHeight / values.zoomFactor;
            values.left = values.centerX - values.width / 2;
            values.top = values.centerY - values.height / 2;
        }
    },
};
//# sourceMappingURL=ViewPortMath.js.map